import {
  GALLERY_PAGE_SIZES,
  type GalleryPageSize,
} from '../../../types/userConfig';
import { useUserConfig } from '../../../userConfig/useUserConfig';
import { useGalleryImagesQuery } from '../queries/useGalleryImagesQuery';
import { useGalleryListSearchParams } from './useGalleryListSearchParams';

export function useGalleryPage() {
  const { galleryImagesPageSize, setGalleryImagesPageSize, isUserConfigReady } =
    useUserConfig();
  const {
    galleryPage,
    searchInput,
    listOptions,
    hasActiveGallerySearch,
    handleSearchChange,
    setGalleryPage,
  } = useGalleryListSearchParams(galleryImagesPageSize);

  const imagesQuery = useGalleryImagesQuery({
    listOptions,
    enabled: isUserConfigReady,
  });

  const images = imagesQuery.data ?? [];
  const hasPreviousGalleryPage = galleryPage > 1;
  const hasNextGalleryPage = images.length === galleryImagesPageSize;
  const isPageLoading = imagesQuery.isLoading || !isUserConfigReady;

  const handleManualRefresh = () => {
    void imagesQuery.refetch();
  };

  const handleGalleryPageSizeChange = (value: string) => {
    const parsedValue = Number(value);
    if (!GALLERY_PAGE_SIZES.some((size) => size === parsedValue)) {
      return;
    }

    setGalleryImagesPageSize(parsedValue as GalleryPageSize);
    setGalleryPage(1);
  };

  return {
    imagesQuery,
    images,
    galleryPage,
    searchInput,
    hasActiveGallerySearch,
    handleSearchChange,
    setGalleryPage,
    handleManualRefresh,
    hasPreviousGalleryPage,
    hasNextGalleryPage,
    galleryImagesPageSize,
    handleGalleryPageSizeChange,
    isPageLoading,
  };
}
